module.exports = "/lucky-balls/img/icons/96.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/icons/96.png
// module id = 1063
// module chunks = 0